import React from 'react';
import styles from './CardSummary.module.scss';
import LineChart from '@/components/atomics/Chart/Line';
import Tooltip from '@/components/atomics/Tooltip';
import Chips from '@/components/atomics/Chips';
import Icon from '@/components/atomics/Icons';

type CardSummaryProps = {
  border?: boolean;
  color?: string;
  description?: string;
  title: string;
  value: React.ReactNode;
  percentage?: number;
  className?: string;
  tooltip?: 'top_center' | 'top_left' | 'top_right' | 'bottom_center' | 'bottom_left' | 'bottom_right';
  variant: 'success' | 'error' | 'warning';
};

const className = 'card-summary';

const CardSummary: React.FC<CardSummaryProps> = ({ border = true, color, description, title, value, percentage = 0, variant,
  tooltip = 'top_center' }) => {
  const extractColor = () => {
    switch (variant) {
      case 'success':
        return '#32D583'; // Green
      case 'error':
        return '#FF525280'; // Red
      case 'warning':
        return '#F7900980'; // Yellow
      default:
        return '#000000'; // Default color
    }
  };

  return (
    <div className={[styles[className], border ? styles[className + '__border'] : ''].join(' ')}>
      <div className={styles[className + '__info']}>
        <div>
          <div className={styles[className + '__info_title']}>
            {title}
            {description && <Tooltip message={description} position={tooltip} width={250} />}
          </div>
          <div className={styles[className + '__info_value']}>{value}</div>
        </div>
        {percentage ? <div className={styles[className + '__info_caption']}>
          <Chips icon={<Icon data-testid="cardsummary-icon" name="ArrowUp" />}
            label={`${percentage}%`} variant={variant} /> from week
        </div> : ''}
      </div>
      <div className={styles[className + '__chart']}>
        <LineChart colors={[color ?? extractColor(), '#FFFFFF']} data={[10, 15, 3, 40, 20]} />
      </div>
    </div>
  );
};

export default CardSummary;